function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid.js";
export var Component = function Component(_ref) {
  var id = _ref.id,
      verticalAlignContent = _ref.verticalAlignContent,
      props = _objectWithoutProperties(_ref, ["id", "verticalAlignContent"]);

  return React.createElement(Grid.Column, _extends({}, props, {
    id: id,
    verticalAlign: verticalAlignContent
  }));
};
Component.displayName = 'GridColumn';
Component.defaultProps = {
  id: null,
  verticalAlignContent: 'top',
  width: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  verticalAlignContent: PropTypes.oneOf(['bottom', 'middle', 'top']),
  width: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
} : {};